var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundForgotPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "403px",
    height: "675px",
    viewBox: "0 0 403 675",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "08. Navigation/01. Product Navigation/02. Product Navigation - DevOps") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 369,
    height: 641,
    rx: 32
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.3%",
    y: "-3.2%",
    width: "116.5%",
    height: "109.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 10,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0663961271   0 0 0 0 0.135818416   0 0 0 0 0.556980299  0 0 0 0.542285839 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "21.1455489%",
    y1: "49.5474319%",
    x2: "11.2863441%",
    y2: "50.5769298%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#412108",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#361B06",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.0876783%",
    y1: "47.6084145%",
    x2: "52.8293536%",
    y2: "50.84578%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351C07",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331B07",
    stopOpacity: 0.659664554,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back-Office-Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "08.-Navigation/01.-Product-Navigation/02.-Product-Navigation---DevOps",
    transform: "translate(17.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#2947FD",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M866.709454,210.370445 C1207.03245,210.370445 1482.91875,133.690503 1482.91875,39.101 C1482.91875,-55.4885028 1207.03245,-132.168445 866.709454,-132.168445 C526.386458,-132.168445 -300.104835,21.4786069 113.140811,39.101 C526.386458,56.7233931 526.386458,210.370445 866.709454,210.370445 Z",
    fill: "url(#linearGradient-4)",
    opacity: 0.430431548,
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0353664,932.655 C497.442632,932.655 2412.3375,523.056 1088.55,582.669 C-235.2375,642.282 208.681733,338.448 -73.8,289.241234 C-356.281733,240.034469 -1324.49487,704.308766 -824.933384,725.612 C-325.371899,746.915234 -325.371899,932.655 86.0353664,932.655 Z",
    id: "Oval-Copy",
    fill: "url(#linearGradient-5)",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(25.000000, 523.000000)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundForgotPassword);
export default __webpack_public_path__ + "static/media/backgroundForgotPassword.f9685f72c0e9c66519e2426c92b73e77.svg";
export { ForwardRef as ReactComponent };